/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Nov 28 2024
 **/
import { useState } from "react";

export default function useWakeLock() {
	const [wakeLockState, setWakeLockState] = useState<WakeLockSentinel | null>(null);

	const startWakeLock = async () => {
		try {
			if (!wakeLockState) {
				const wakeLockSentinel = await navigator.wakeLock.request("screen");
				setWakeLockState(wakeLockSentinel);
				wakeLockSentinel.addEventListener("release", () => {
					setWakeLockState(null);
				});
			}
		} catch (err) {
			console.error("error", err);
		}
	};

	const endWakeLock = async () => {
		try {
			if (wakeLockState) {
				await wakeLockState.release();
				setWakeLockState(null);
			}
		} catch (err) {
			console.error("error", err);
		}
	};

	return { startWakeLock, endWakeLock };
}
